axios = require('axios')

API_TOKEN = process.env.VUE_APP_API_TOKEN || 'recess.api.token'

class RecessAPI
  @memberToken: ''
  @brandRepId: ''
  @appModule: ''

  @slugForApp: (slug)->
    appSlug = "#{slug}".trim()
    return appSlug if appSlug.startsWith "#{@appModule}/"
    return slug if '' is "#{@appModule}".trim()
    appSlug = "#{@appModule}/#{slug}"
    appSlug
  @configureAppForMember: (member)->
    @memberToken = member.token
    @appModule = switch member?.market_type
      when 'supplier' then 'supply'
      when 'buyer' then 'buy'
    @appModule = 'super' if member.super_user
  @configureAppForPartnerBuy: (partnerBuy) ->
    @brandRepId = partnerBuy?.brandRep?.id
    @configureAppModuleForPartnerBuy()
  @configureAppModuleForPartnerBuy: ->
    @appModule = "partner_buy/brand_reps/#{@brandRepId}" if @brandRepId
    @appModule ||= 'partner_buy'

  @fetch: (slug, params = {}) ->
    new Promise (resolve, reject) =>
      try
        headers = @headers()
        params.render_as_event = true
        { data } = await axios.get @urlForSlug(slug), { headers, params }
        resolve data
      catch err
        reject err

  @fetchMe: (params={})->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/me"
      try
        headers = @headers()
        params.render_as_event = true
        { data } = await axios.get path, { headers, params }
        resolve data
      catch err
        reject err

  @fetchMarketplace: (params={})->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/marketplace"
      try
        headers = @headers()
        params.render_as_event = true
        { data } = await axios.get path, { headers, params }
        resolve data
      catch err
        reject err

  @fetchProgressBars: (params={}) ->
    path = @urlForSlug('workflow_progress_bars')
    try
      headers = @headers()
      { data } = await axios.get path, { headers, params }
      return data
    catch err
      return err

  @fetchProgress: (params={}) ->
    path = @urlForSlug('progress')
    try
      headers = @headers()
      { data } = await axios.get path, { headers, params }
      return data
    catch err
      return err

  @search: (collectionSlug, params = {}) ->
    new Promise (resolve, reject) =>
      try
        headers = @headers()
        params.render_as_event = true
        { data } = await axios.get @urlForSlug("#{collectionSlug}/text_search"), { headers, params }
        resolve data.item.collection
      catch err
        reject err
  @saveItem: (collectionSlug, resourceName, item) ->
    new Promise (resolve, reject) =>
      payload = { }
      payload[resourceName] = item
      slug = @urlForSlug collectionSlug
      # slug = @urlForSlug collectionSlug if item.id? # ???
      try
        headers = @headers()
        params = render_as_event: true
        if item.id?
          { data } = await axios.patch slug, payload, { headers, params }
        else
          { data } = await axios.post slug, payload, { headers, params }
        resolve data
      catch err
        reject err
  @triggerResource: (resourceSlug, action, data)->
    new Promise (resolve, reject) =>
      data ||= {}
      event = { data }
      payload = { event }
      slug = @urlForSlug "#{resourceSlug}/triggers/#{action}"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post slug, payload, { headers, params }
        resolve data
      catch err
        reject err
  @authenticate: (payload) ->
    @memberToken = ''
    @appModule = ''
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/authenticate"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @changePassword: (payload) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/change_password"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @forgotPassword: (payload) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/password_reset_request"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @resetPassword: (token, payload) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/password_reset_request/#{token}"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.patch path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @registerMagicLink: (payload) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/register_magic_link"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @signup: (marketType, payload) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/signup"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, payload, { headers, params }
        resolve data
      catch err
        reject err
  @logout: ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/logout"
      try
        headers = @headers()
        params = render_as_event: true
        { data } = await axios.post path, {}, { headers, params }
        resolve data
      catch err
        reject err
  @switchUser: (userId) ->
    new Promise (resolve, reject) =>
      path = "#{@endpointPath()}/super/super_users/switch_user/#{userId}"
      try
        headers = @headers()
        params = render_as_event: true
        console.log headers, params
        { data } = await axios.post path, {}, { headers, params }
        resolve data
      catch err
        reject err

  @destroyItem: (slug) ->
    new Promise (resolve, reject) =>
      try
        headers = @headers()
        params = render_as_event : true
        { data } = await axios.delete @urlForSlug(slug), { headers, params }
        resolve data
      catch err
        reject err
  @uploadEventPhoto: (eventId, file) ->
    new Promise (resolve, reject) =>
      try
        headers = @headers()
        url = "#{@endpoint()}/uploads/events/#{eventId}/promotable_photo"
        payload = new FormData
        payload.append('file', file)
        { data } = await axios.post url, payload, { headers }
        resolve data
      catch err
        reject err
  @destroyAttachment: (id) ->
    new Promise (resolve, reject) =>
      try
        headers = @headers()
        url = "#{@endpoint()}/uploads/#{id}"
        console.log "DESTROY #{url}"
        { data } = await axios.delete url, { headers }
        resolve data
      catch err
        reject err
  @getGeoCoordinates: (location) ->
    new Promise (resolve, reject) =>
      try
        apiKEY = (process.env.VUE_APP_GOOGLE_MAPS_JS_API_KEY || process.env.VUE_APP_GOOGLE_API_KEY)
        url = "https://maps.googleapis.com/maps/api/geocode/json?address=#{location}&key=#{apiKEY}"
        { data } = await axios.get url
        coords = false
        results = data.results[0]?.geometry?.location
        coords = { lat: results.lat, lng: results.lng } if results?
        resolve coords
      catch err
        reject err
  @getGeoLocation: (coordinates) ->
    new Promise (resolve, reject) =>
      try
        apiKEY = (process.env.VUE_APP_GOOGLE_MAPS_JS_API_KEY || process.env.VUE_APP_GOOGLE_API_KEY)
        url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=#{coordinates.lat}, #{coordinates.lng}&key=#{apiKEY}"
        { data } = await axios.get url
        location = (data.results.filter (l) -> l.types.includes('street_address'))[0]
        resolve location
      catch err
        reject err
  @getTimeZone: (coordinates) ->
    new Promise (resolve, reject) =>
      try
        timestamp = new Date() / 1000
        apiKEY = (process.env.VUE_APP_GOOGLE_MAPS_JS_API_KEY || process.env.VUE_APP_GOOGLE_API_KEY)
        url = "https://maps.googleapis.com/maps/api/timezone/json?location=#{coordinates.lat}, #{coordinates.lng}&timestamp=#{timestamp}&key=#{apiKEY}"
        { data } = await axios.get url
        resolve data
      catch err
        reject err
  @get: (path, headers, params) ->
    url = "#{@endpoint()}/#{path}"
    { data } = await axios.get url, { headers, params }
    data
  @post: (path, body, headers, params) ->
    url = "#{@endpoint()}/#{path}"
    { data } = await axios.post url, body, { headers, params }
    data
  @put: (path, body, headers, params) ->
    url = "#{@endpoint()}/#{path}"
    { data } = await axios.put url, body, { headers, params }
    data
  @trigger: (path, action, body, headers, params) ->
    url = "#{@endpoint()}/#{path}/triggers/#{action}"
    payload = { event: { data: body || {} } }
    { data } = await axios.post url, payload, { headers, params }
    data
  @uploadFile: (path, file, headers, params) ->
    formData = new FormData()
    formData.append 'file', file
    { data } = await axios.post path, formData, { headers, params }
    data

  @endpoint: -> process.env.VUE_APP_API_ENDPOINT or ''
  @path : -> process.env.VUE_APP_API_PATH or 'api/v2'
  @endpointPath: -> "#{@endpoint()}/#{@path()}"
  @slugForId: (collectionSlug, id) -> "#{collectionSlug}/#{id}"
  @urlForSlug: (slug) -> url = "#{@endpointPath()}/#{@appModule}/#{slug}"
  @headers: ->
    X_RECESS_API_TOKEN : API_TOKEN
    X_AUTH_TOKEN : @memberToken
    X_BRAND_REP_ID : @brandRepId 

export default RecessAPI